// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::after, *::before{
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    font-family: inherit;
    font-size: inherit;
}

body{
    font-family: 'Open Sans', Arial, Helvetica, sans-serif;
    color: #212633;
    --fontScaler: 1;
    font-size: calc(14px * var(--fontScaler));
}

.button{
    cursor: pointer;
    user-select: none;
}

.saveButton{
    transition-duration: 200ms;
}

.saveButton:hover{
    background-color: #ffb84e;
}


.scroll {
    scrollbar-width: unset;
}

.scroll::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.scroll::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 10px;    
}

.scroll::-webkit-scrollbar-thumb {
    height: 5%;
    background-image: linear-gradient(90deg, #0000 0%, #0000 20%,#999999 20%, #999999 80%, #0000 80%, #0000 100%);
    border: 0px solid #000;
    border-radius: 10px;
    cursor: pointer;
}

/*.scroll {
    scrollbar-width: thin;
    scrollbar-color: #FF6633;
}*/
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,sDAAsD;IACtD,cAAc;IACd,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,6GAA6G;IAC7G,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;EAGE","sourcesContent":["*, *::after, *::before{\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n}\n\nbody{\n    font-family: 'Open Sans', Arial, Helvetica, sans-serif;\n    color: #212633;\n    --fontScaler: 1;\n    font-size: calc(14px * var(--fontScaler));\n}\n\n.button{\n    cursor: pointer;\n    user-select: none;\n}\n\n.saveButton{\n    transition-duration: 200ms;\n}\n\n.saveButton:hover{\n    background-color: #ffb84e;\n}\n\n\n.scroll {\n    scrollbar-width: unset;\n}\n\n.scroll::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n}\n\n.scroll::-webkit-scrollbar-track {\n    background: #fff;\n    border-radius: 10px;    \n}\n\n.scroll::-webkit-scrollbar-thumb {\n    height: 5%;\n    background-image: linear-gradient(90deg, #0000 0%, #0000 20%,#999999 20%, #999999 80%, #0000 80%, #0000 100%);\n    border: 0px solid #000;\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n/*.scroll {\n    scrollbar-width: thin;\n    scrollbar-color: #FF6633;\n}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
